import { themeVariables } from "Components/theme";
import { PRESENTATION_TEXT_FILTER_DEF_ID } from "../../constants";
export default (defs) => {
    const filterObject = document.createElementNS("http://www.w3.org/2000/svg", "filter");
    filterObject.setAttribute("x", "0");
    filterObject.setAttribute("y", "-0.2");
    filterObject.setAttribute("width", "1");
    filterObject.setAttribute("height", "1.4");
    filterObject.setAttribute("id", PRESENTATION_TEXT_FILTER_DEF_ID);
    let child = document.createElementNS("http://www.w3.org/2000/svg", "feFlood");
    child.setAttribute("flood-color", themeVariables["timeline-presentation-label-bg"]);
    filterObject.appendChild(child);
    child = document.createElementNS("http://www.w3.org/2000/svg", "feGaussianBlur");
    child.setAttribute("stdDeviation", "2");
    filterObject.appendChild(child);
    child = document.createElementNS("http://www.w3.org/2000/svg", "feComponentTransfer");
    let table = document.createElementNS("http://www.w3.org/2000/svg", "feFuncA");
    table.setAttribute("type", "table");
    table.setAttribute("tableValues", "0 0 0 1");
    child.appendChild(table);
    filterObject.appendChild(child);
    child = document.createElementNS("http://www.w3.org/2000/svg", "feComponentTransfer");
    table = document.createElementNS("http://www.w3.org/2000/svg", "feFuncA");
    table.setAttribute("type", "table");
    table.setAttribute("tableValues", "0 1 1 1 1 1 1 1");
    child.appendChild(table);
    filterObject.appendChild(child);
    child = document.createElementNS("http://www.w3.org/2000/svg", "feComposite");
    child.setAttribute("in", "SourceGraphic");
    child.setAttribute("operator", "over");
    filterObject.appendChild(child);
    defs === null || defs === void 0 ? void 0 : defs.appendChild(filterObject);
};
